import * as requestFromServer from "./dashboardCrud";
import { dashboardSlice, callTypes } from "./dashboardSlice";
import { toast } from "react-hot-toast";
import { AppDispatch } from "../store";

const { actions } = dashboardSlice;

export const getDashboardAnalytics = (data?: any) => (dispatch: AppDispatch | any) => {
  dispatch(
    actions.startCall({
      callType: callTypes.list,
    }),
  );
  return requestFromServer
    .getDashboardAnalytics(data)
    .then((response) => {
      dispatch(
        actions.getDashboardAnalytics({
          results: response?.data.results,
        }),
      );
    })
    .catch((error) => {
      error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
        }),
      );
      toast.error(error?.response?.data?.message);
    });
};
